module.exports = __webpack_public_path__ + "static/media/link_active_black.610a60c2.svg";